import Handlebars from "handlebars";

Handlebars.registerHelper("curveHandler", function (type, options) {
  var position = options || "bottom";
  var curves = {
    "curve-a":
      '<svg class="hero-curve hero-white" viewBox="0 0 1441 117" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
        <g id="Sparkle---Features---Make" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0.000000, -602.000000)">\
            <g id="Group" class="hero-curve-fill" transform="translate(0.000000, 219.000000)" fill="#FFFFFF">\
                <g id="Curves/Bottom-A" transform="translate(0.000000, 383.000000)">\
                    <path d="M1439.9266,0.545305578 L1439.9266,16.2243282 C1242.49485,12.4991923 1098.16809,32.8596543 846.986102,65.4164473 C538.920299,105.3462 265.25518,132.430827 0,107.899371 L0,0.545305578 L1439.9266,0.545305578 Z" id="Rectangle" transform="translate(719.963300, 58.897335) scale(1, -1) translate(-719.963300, -58.897335) "></path>\
                </g>\
            </g>\
        </g>\
    </svg>',
    "curve-b":
      '<svg class="hero-curve hero-white-deep" preserveAspectRatio="none" viewBox="0 0 1442 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
        <g id="Curves/Bottom-B" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
            <path d="M1441.05212,59 L1440.92575,26.7982613 C878.632516,-13.5665566 704.02042,-4.15980474 335.038224,27.4200976 C-33.9439716,59 107.239105,49.4145277 -5.6531622e-14,55.5140433 L-9.09494702e-13,59 L1441.05212,59 Z" class="hero-curve-fill" transform="translate(720.526061, 29.500000) scale(-1, 1) translate(-720.526061, -29.500000) "></path>\
        </g>\
    </svg>',
    "curve-c":
      '<svg class="hero-curve hero-blue-a" preserveAspectRatio="none" viewBox="0 0 1440 114" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
        <g id="Sparkle---Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0.000000, -990.000000)">\
            <g id="Hero-Banner" transform="translate(0.000000, -3.000000)" class="hero-curve-fill" fill="#EFF4F5">\
                <g id="Group-59">\
                    <g id="Curves/Bottom-C" transform="translate(0.000000, 993.000000)">\
                        <g id="Curves/Bottom-A">\
                            <path d="M1439.9266,0.545305578 L1439.9266,15.2243282 C1242.49485,11.4991923 1098.16809,31.8596543 846.986102,64.4164473 C538.920299,104.3462 265.25518,131.430827 0,106.899371 L0,0.545305578 L1439.9266,0.545305578 Z" id="Rectangle" transform="translate(719.963300, 58.397335) scale(1, -1) translate(-719.963300, -58.397335) "></path>\
                        </g>\
                    </g>\
                </g>\
            </g>\
        </g>\
    </svg>',
    "curve-d":
      '<svg class="hero-curve hero-blue-b" preserveAspectRatio="none" viewBox="0 0 1440 114" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
        <g id="Features:-Measure" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0.000000, -2019.000000)">\
            <g id="Curves/Top-A" transform="translate(0.000000, 2016.000000)" class="hero-curve-fill" fill="#EFF4F5">\
                <path d="M1440,117 L1439.9266,3.67902265 C1242.49485,-0.0461132754 1098.16809,20.3143487 846.986102,52.8711417 C538.920299,92.8008942 265.25518,119.885522 0,95.3540659 L0.0733991717,117 L1440,117 Z" id="Rectangle"></path>\
            </g>\
        </g>\
    </svg>',
    "curve-e":
      '<svg class="hero-curve hero-blue-c" preserveAspectRatio="none" viewBox="0 0 1440 80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
        <g id="Sparkle---Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0.000000, -4619.000000)">\
            <g id="Group-3" transform="translate(0.000000, 4618.000000)" class="hero-curve-fill" fill="#59ADCB">\
                <path d="M1441.05212,0.905567536 L1440.92575,42.8756403 C878.632516,-11.8539741 704.02042,0.90039792 335.038224,43.7187722 C-33.9439716,86.5371465 107.239105,73.540452 1.30771043e-12,81.8106278 L-9.09494702e-13,0.905567536 L1441.05212,0.905567536 Z" id="Curves/Bottom-MediumBlue" transform="translate(720.526061, 41.358098) scale(-1, -1) translate(-720.526061, -41.358098) "></path>\
            </g>\
        </g>\
    </svg>',
    "curve-f":
      '<svg class="hero-curve hero-white-deep" preserveAspectRatio="none" viewBox="0 0 1442 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\
        <g id="Curves/Top-B" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
            <path d="M1441.05212,59 L1440.92575,26.7982613 C878.632516,-13.5665566 704.02042,-4.15980474 335.038224,27.4200976 C-33.9439716,59 107.239105,49.4145277 -5.6531622e-14,55.5140433 L-9.09494702e-13,59 L1441.05212,59 Z" class="hero-curve-fill" transform="translate(720.526061, 29.500000) scale(-1, -1) translate(-720.526061, -29.500000) "></path>\
        </g>\
    </svg>',
  };

  if (type !== "none" && curves[type]) {
    return new Handlebars.SafeString(
      '<div class="hero-curve-wrapper hero-' + type + " hero-curve-" + position + '">' + curves[type] + "</div>",
    );
  } else {
    return "";
  }
});
